import React, { Component } from "react";
import { Link } from "react-router-dom";
export class sildebar2 extends Component {
  render() {
    return (
      <div>
        <div className="widget widget-nav-menu">
          <ul className="widget-menu">
            <li>
              <Link
                activeClassName="active"
                to={process.env.PUBLIC_URL + "/lead-to-cash-hi-tech"}
              >
                Lead to Cash
              </Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/cpq-solutions-for-saas"}>
                CPQ Solutions for SaaS
              </Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/revenue-management"}>
                Revenue Management
              </Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/agile-product-development"}>
                Agile Product Development
              </Link>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default sildebar2;
